import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDialogModule } from '@angular/material/dialog';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCardModule } from '@angular/material/card';
import { NosotrosComponent } from './pages/nosotros/nosotros.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatInputModule } from '@angular/material/input';
import { FooterndComponent } from './components/footernd/footernd.component';
import { HttpClientModule } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { FormsModule } from '@angular/forms';
import { PipesModule } from './pipe.module';
import { NoticiaComponent } from './pages/noticia/noticia.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTreeModule } from '@angular/material/tree';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { MatMenuModule } from '@angular/material/menu';
import { RadioOnlineComponent } from './components/radio-online/radio-online.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PublicidadComponent } from './components/publicidad/publicidad.component';
import { PagesComponent } from './pages/pages.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WeatherComponent } from './components/weather/weather.component';
import { WeatherSnackComponent } from './components/weather-snack/weather-snack.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { YoutubePipe } from './pipes/filename.pipe';
import { VideoComponent } from './components/video/video.component';
import { HomeNewComponent } from './pages/home-new/home-new.component';
import { SliderComponent } from './components/slider/slider.component';
import { CategorySlidesComponent } from './pages/home-new/category-slides/category-slides.component';
import { SliderItemDirective } from './components/slider/slider-item.directive';
import { TwoRowsSliderComponent } from './components/two-rows-slider/two-rows-slider.component';
import { SugestSliderComponent } from './pages/noticias/sugest-slider/sugest-slider.component';
import { TwoRowsSliderItemDirective } from './components/two-rows-slider/slider-item.directive';
import { RecentSlidesComponent } from './pages/home-new/recent-slides/recent-slides.component';
import { CardSliderComponent } from './components/card-slider/card-slider.component';
import { FooterNewComponent } from './components/footer-new/footer-new.component';
import { NoticiasNewComponent } from './pages/noticias-new/noticias-new.component';
import { EnvivoNewComponent } from './pages/envivo-new/envivo-new.component';
import { SuscribeteNewComponent } from './pages/suscribete-new/suscribete-new.component';
import { NoticiaNewComponent } from './pages/noticia-new/noticia-new.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { RadioNewComponent } from './components/radio-new/radio-new.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {AngularFireAnalyticsModule, UserTrackingService} from '@angular/fire/analytics'

@NgModule({
  declarations: [
    AppComponent,
    NosotrosComponent,
    FooterndComponent,
    NoticiaComponent,
    RadioOnlineComponent,
    PublicidadComponent,
    PagesComponent,
    WeatherComponent,
    WeatherSnackComponent,
    YoutubePipe,
    VideoComponent,
    HomeNewComponent,
    SliderComponent,
    CategorySlidesComponent,
    SliderItemDirective,
    TwoRowsSliderItemDirective,
    TwoRowsSliderComponent,
    SugestSliderComponent,
    RecentSlidesComponent,
    CardSliderComponent,
    FooterNewComponent,
    NoticiasNewComponent,
    EnvivoNewComponent,
    SuscribeteNewComponent,
    NoticiaNewComponent,
    SafeHtmlPipe,
    RadioNewComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatGridListModule,
    NgbModule,
    MatCardModule,
    HttpClientModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    FontAwesomeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatTreeModule,
    MatPaginatorModule,
    NgxMaterialTimepickerModule,
    FormsModule,
    PipesModule,
    MatExpansionModule,
    MatTableModule,
    MatDialogModule,
    MatSliderModule,
    AngularFireAnalyticsModule,
    MatMenuModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    MDBBootstrapModule.forRoot(),
    MatCheckboxModule,
    MatSnackBarModule,
    MatDividerModule,
    MatListModule,
    InfiniteScrollModule
  ],
  providers: [UserTrackingService],
  bootstrap: [AppComponent]
})
export class AppModule { }
